import React from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames';

import { ANALYTICS_VIEW_FEATURE_LOCATIONS } from 'dpl/constants/analytics';
import BreederProfileCurrentLittersSectionSkeleton from 'dpl/components/BreederProfile/Show/skeletons/BreederProfileCurrentLittersSectionSkeleton';
import Button from 'dpl/common/design_system/Button';
import useToggle from 'dpl/shared/hooks/useToggle';

import useLitters from '../../hooks/useLitters';
import { PuppiesListItem } from './PuppiesList';

const COLLAPSED_PUPPIES_COUNT = 5;

export default function AdultDogsList() {
  const { breederProfileId } = useSelector(({ server }) => server);
  const {
    isFetchingCurrentLitters,
    availableAdultDogs,
    sortedAvailablePuppies
  } = useLitters();

  const isCollapsible = availableAdultDogs.length > COLLAPSED_PUPPIES_COUNT;
  const [isCollapsed, toggleIsCollapsed] = useToggle(true);

  if (isFetchingCurrentLitters) {
    return <BreederProfileCurrentLittersSectionSkeleton />;
  }

  if (availableAdultDogs.length === 0) {
    return null;
  }

  const listings = isCollapsed
    ? availableAdultDogs.slice(0, COLLAPSED_PUPPIES_COUNT)
    : availableAdultDogs;

  const hasAvailablePuppies = sortedAvailablePuppies.length > 0;

  return (
    <div
      className={classnames(
        'AvailableDogsList container-xxl flex flex-column pb6',
        {
          pt6: hasAvailablePuppies
        }
      )}
    >
      <h3 className="mb6 font-24 lh-title">Available adult dogs</h3>
      <ul className="grid gap-24">
        {listings.map((adultDog, idx) => (
          <PuppiesListItem
            key={adultDog.id}
            position={idx + 1}
            allPuppies={availableAdultDogs}
            puppy={adultDog}
            breederProfileId={breederProfileId}
            viewFeatureLocation={
              ANALYTICS_VIEW_FEATURE_LOCATIONS.AVAILABLE_ADULT_DOGS
            }
          />
        ))}
      </ul>

      {isCollapsible && (
        <Button
          className="font-16 stone-700 w-100 mt4"
          variant="outline"
          size="default"
          onClick={toggleIsCollapsed}
        >
          {isCollapsed ? 'See more adult dogs' : 'See less adult dogs'}
        </Button>
      )}
    </div>
  );
}
